import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserInfo } from '../../models/user-info.model';

@Component({
  selector: 'app-welcome-user',
  templateUrl: './welcome-user.component.html',
  styleUrls: ['./welcome-user.component.scss'],
})
export class WelcomeUserComponent {
  public currentUser$: Observable<UserInfo>;
  constructor(private authService: AuthService) {
    this.currentUser$ = this.authService.getCurrentUser();
  }
}
